import _objectSpread from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "header"
};
var _hoisted_2 = {
  "class": "header-text"
};
var _hoisted_3 = {
  "class": "header-close-icon"
};
var _hoisted_4 = {
  "class": "read-status-counter-container"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  "class": "status-text"
};
var _hoisted_7 = {
  "class": "status-count"
};
var _hoisted_8 = {
  "class": "read-status-member-list"
};
var _hoisted_9 = {
  key: 0,
  "class": "empty-list-tip"
};
var _hoisted_10 = {
  "class": "username"
};
var _hoisted_11 = {
  "class": "username"
};
var _hoisted_12 = {
  key: 2,
  "class": "fetch-more-container"
};
import { ref, onMounted, watch, nextTick } from "../../../../adapter-vue";
import { TUIStore, TUIChatService, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import closeIcon from "../../../../assets/icon/icon-close.svg";
import Icon from "../../../common/Icon.vue";
import Overlay from "../../../common/Overlay/index.vue";
import Avatar from "../../../common/Avatar/index.vue";
import FetchMore from "../../../common/FetchMore/index.vue";
import { isMobile } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["setReadReciptPanelVisible"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var lastUnreadCursor = "";
    var lastReadCursor = "";
    var tabNameList = ['unread', 'read'];
    var isListFetchCompleted = {
      unread: false,
      read: false,
      close: false
    };
    var isPullDownFetching = ref(false);
    var isPanelClose = ref(false);
    var isFirstLoadFinished = ref(false);
    var isStopFetchMore = ref(false);
    var currentTabName = ref('unread');
    var tabInfo = ref(generateInitalTabInfo());
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initAndRefetchReceiptInfomation();
          case 2:
            nextTick(function () {
              isFirstLoadFinished.value = true;
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(
    // uniapp下监听不到数据变化
    function () {
      return props.message.readReceiptInfo.readCount;
    }, function () {
      initAndRefetchReceiptInfomation();
    });
    function fetchGroupMessageRecriptMemberListByType() {
      return _fetchGroupMessageRecriptMemberListByType.apply(this, arguments);
    }
    function _fetchGroupMessageRecriptMemberListByType() {
      _fetchGroupMessageRecriptMemberListByType = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var readType,
          message,
          unreadResult,
          readResult,
          _message$readReceiptI,
          totalUnreadCount,
          totalReadCount,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              readType = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'all';
              message = TUIStore.getMessageModel(props.message.ID);
              unreadResult = {};
              readResult = {};
              if (!(readType === 'all' || readType === 'unread')) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return TUIChatService.getGroupMessageReadMemberList({
                message: message,
                filter: 1,
                cursor: lastUnreadCursor,
                count: 100
              });
            case 7:
              unreadResult = _context2.sent;
              if (unreadResult) {
                lastUnreadCursor = unreadResult.data.cursor;
                if (unreadResult.data.isCompleted) {
                  isListFetchCompleted.unread = true;
                }
              }
            case 9:
              if (!(readType === 'all' || readType === 'read')) {
                _context2.next = 14;
                break;
              }
              _context2.next = 12;
              return TUIChatService.getGroupMessageReadMemberList({
                message: message,
                filter: 0,
                cursor: lastReadCursor,
                count: 100
              });
            case 12:
              readResult = _context2.sent;
              if (readResult) {
                lastReadCursor = readResult.data.cursor;
                if (readResult.data.isCompleted) {
                  isListFetchCompleted.read = true;
                }
              }
            case 14:
              // Fetch the total number of read and unread users
              _message$readReceiptI = message.readReceiptInfo, totalUnreadCount = _message$readReceiptI.unreadCount, totalReadCount = _message$readReceiptI.readCount;
              return _context2.abrupt("return", {
                unreadResult: _objectSpread({
                  count: totalUnreadCount
                }, unreadResult.data),
                readResult: _objectSpread({
                  count: totalReadCount
                }, readResult.data)
              });
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchGroupMessageRecriptMemberListByType.apply(this, arguments);
    }
    function pullDownFetchMoreData() {
      return _pullDownFetchMoreData.apply(this, arguments);
    }
    /**
     * Initializes and refetches receipt information.
     *
     * @return {Promise<void>} A promise that resolves when the function has completed.
     */
    function _pullDownFetchMoreData() {
      _pullDownFetchMoreData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$fetchGroupMess, unreadResult, readResult;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(isListFetchCompleted[currentTabName.value] || isPullDownFetching.value)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              isPullDownFetching.value = true;
              _context3.next = 5;
              return fetchGroupMessageRecriptMemberListByType(currentTabName.value);
            case 5:
              _yield$fetchGroupMess = _context3.sent;
              unreadResult = _yield$fetchGroupMess.unreadResult;
              readResult = _yield$fetchGroupMess.readResult;
              checkStopFetchMore();
              try {
                tabInfo.value.unread.memberList = tabInfo.value.unread.memberList.concat(unreadResult.unreadUserInfoList || []);
                tabInfo.value.read.memberList = tabInfo.value.read.memberList.concat(readResult.readUserInfoList || []);
              } finally {
                isPullDownFetching.value = false;
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _pullDownFetchMoreData.apply(this, arguments);
    }
    function initAndRefetchReceiptInfomation() {
      return _initAndRefetchReceiptInfomation.apply(this, arguments);
    }
    /**
     * Checks if the fetch more operation should be stopped
     * by IntersetctionObserver.disconnect().
     *
     * @return {void}
     */
    function _initAndRefetchReceiptInfomation() {
      _initAndRefetchReceiptInfomation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$fetchGroupMess2, unreadResult, readResult;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              lastUnreadCursor = "";
              lastReadCursor = "";
              isStopFetchMore.value = false;
              isListFetchCompleted.unread = false;
              isListFetchCompleted.read = false;
              _context4.next = 7;
              return fetchGroupMessageRecriptMemberListByType('all');
            case 7:
              _yield$fetchGroupMess2 = _context4.sent;
              unreadResult = _yield$fetchGroupMess2.unreadResult;
              readResult = _yield$fetchGroupMess2.readResult;
              checkStopFetchMore();
              resetTabInfo('read', readResult.count, readResult.readUserInfoList);
              resetTabInfo('unread', unreadResult.count, unreadResult.unreadUserInfoList);
              resetTabInfo('close');
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _initAndRefetchReceiptInfomation.apply(this, arguments);
    }
    function checkStopFetchMore() {
      if (isListFetchCompleted.read && isListFetchCompleted.unread) {
        isStopFetchMore.value = true;
      }
    }
    /**
     * Resets the information of a specific tab.
     *
     * @param {TabName} tabName - The name of the tab to reset.
     * @param {number} [count] - The count to assign to the tab. Optional.
     * @param {IMemberData[]} [memberList] - The list of members to assign to the tab. Optional.
     * @return {void} - This function does not return anything.
     */
    function resetTabInfo(tabName, count, memberList) {
      tabInfo.value[tabName].count = count;
      tabInfo.value[tabName].memberList = memberList || [];
    }
    /**
     * Generates the initial tab information.
     *
     * @return {ITabInfo} The initial tab information.
     */
    function generateInitalTabInfo() {
      return {
        read: {
          tabName: TUITranslateService.t("TUIChat.已读"),
          count: undefined,
          memberList: []
        },
        unread: {
          tabName: TUITranslateService.t("TUIChat.未读"),
          count: undefined,
          memberList: []
        },
        close: {
          tabName: TUITranslateService.t("TUIChat.关闭"),
          count: undefined,
          memberList: []
        }
      };
    }
    /**
     * Toggles the tab name.
     *
     * @param {TabName} tabName - The name of the tab to toggle.
     * @return {void} This function does not return anything.
     */
    function toggleTabName(tabName) {
      currentTabName.value = tabName;
    }
    function closeReadReciptPanel() {
      isPanelClose.value = true;
      setTimeout(function () {
        emits("setReadReciptPanelVisible", false);
      }, 200);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Overlay, {
        "bg-color": 'transparent',
        onClickHandler: closeReadReciptPanel
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass({
              'read-receipt-panel': true,
              'read-receipt-panel-mobile': _unref(isMobile),
              'read-receipt-panel-close-mobile': _unref(isMobile) && _unref(isPanelClose)
            })
          }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("TUIChat.消息详情")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(Icon, {
            size: "12px",
            hotAreaSize: "8",
            file: _unref(closeIcon),
            onOnClick: closeReadReciptPanel
          }, null, 8, ["file"])])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabNameList, function (tabName) {
            return _createElementVNode("div", {
              key: tabName,
              "class": _normalizeClass({
                'read-status-counter': true,
                'active': tabName === _unref(currentTabName)
              }),
              onClick: function onClick($event) {
                return toggleTabName(tabName);
              }
            }, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tabInfo)[tabName].tabName), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(tabInfo)[tabName].count === undefined ? "" : _unref(tabInfo)[tabName].count), 1)], 10, _hoisted_5);
          }), 64))]), _createElementVNode("div", _hoisted_8, [_unref(tabInfo)[_unref(currentTabName)].count === 0 && _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock("div", _hoisted_9, " - " + _toDisplayString(_unref(TUITranslateService).t('TUIChat.空')) + " - ", 1)) : _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_unref(currentTabName) === 'unread' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_unref(tabInfo)[_unref(currentTabName)].memberList, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.userID,
              "class": "read-status-member-container"
            }, [_createVNode(Avatar, {
              "class": "read-status-avatar",
              useSkeletonAnimation: "",
              url: item.avatar || ''
            }, null, 8, ["url"]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.nick || item.userID), 1)]);
          }), 128)) : _createCommentVNode("", true), _unref(currentTabName) === 'read' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(tabInfo)[_unref(currentTabName)].memberList, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.userID,
              "class": "read-status-member-container"
            }, [_createVNode(Avatar, {
              "class": "read-status-avatar",
              useSkeletonAnimation: "",
              url: item.avatar
            }, null, 8, ["url"]), _createElementVNode("div", _hoisted_11, _toDisplayString(item.nick || item.userID), 1)]);
          }), 128)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(FetchMore, {
            isFetching: _unref(isPullDownFetching),
            isTerminateObserve: _unref(isStopFetchMore),
            onOnExposed: pullDownFetchMoreData
          }, null, 8, ["isFetching", "isTerminateObserve"])])) : _createCommentVNode("", true)])], 2)];
        }),
        _: 1
      });
    };
  }
});